// Constants
import { Colors } from "@ms/uno-constants/lib/local/Colors";
import { isWindowsHighContrast } from "../../../utilities/ThemingUtilities";
const isContrastTheme = isWindowsHighContrast();
function setDynamicIconBorderColor(isContrastTheme) {
    if (typeof document !== "undefined") {
        const root = document.documentElement;
        root.style.setProperty("--dynamic-icon-border-color", isContrastTheme ? `${Colors.Black}` : "transparent");
    }
}
setDynamicIconBorderColor(isContrastTheme);
/**
 * Styles for the DynamicIcon in PlanIcon control
 */ export const PlanDynamicIconStyles = {
    subComponentStyles: {
        icon: {
            root: {
                background: `linear-gradient(224deg, ${Colors.gradientColor1} 1.02%, ${Colors.gradientColor2} 123.98%)`,
                color: Colors.White,
                ":hover": {
                    color: Colors.White
                },
                border: "1px solid var(--dynamic-icon-border-color)"
            }
        },
        image: {}
    }
};
